module.exports = __webpack_public_path__ + "static/media/tech-image-three.26cac8ef.png";